module.exports = __webpack_public_path__ + "static/media/enablon-logo-charcoal.f06b07cc.svg";